import { Box } from '@mui/material';
import { styled } from '@mui/system';

import { shadowSpill } from '../cardShadow';

/**
 * The innermost box holding a page of cards, shared by every entity grid.
 *
 * Asymmetric on purpose. The bottom carries the card shadow, so it needs real
 * room; the top only needs enough to lift the first row off the header, and
 * every pixel here comes out of card height.
 */
const FitGrid = styled(Box)({
  flex: 1,
  ...shadowSpill,
  display: 'flex',
  padding: '6px 16px 16px',
});

export default FitGrid;
